import _kebabCase from "lodash/kebabCase";
import { colors } from '@datacamp/waffles-tokens';
const COLORS = Object.keys(colors);
const COLORS_HEX = Object.values(colors);
const checkValidColors = color => {
  if (color != null && !COLORS.includes(color)) {
    // eslint-disable-next-line no-console
    console.error("Use a waffles-compatible color: ".concat(color, " is disallowed"));
  }
};
const formatColor = color => _kebabCase(color).replace('_', '-');
const getColorClass = color => {
  checkValidColors(color);
  return color != null ? "dc-u-color-".concat(formatColor(color)) : '';
};
getColorClass.validColors = COLORS;
getColorClass.validColorsHex = COLORS_HEX;
const getBackgroundClass = color => {
  checkValidColors(color);
  return color != null ? "dc-u-bgc-".concat(formatColor(color)) : '';
};
getBackgroundClass.validColors = COLORS;
const getFillColorClass = color => {
  checkValidColors(color);
  return color != null ? "dc-u-fill-".concat(formatColor(color)) : '';
};
getFillColorClass.validColors = COLORS;
export { getColorClass, getBackgroundClass, getFillColorClass };